export default "__VITE_ASSET__C$y8SPJY__"